import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Input, Select, Typography, Spin, message } from "antd";
import { RightOutlined } from "@ant-design/icons";
import Scrollbars from "react-custom-scrollbars";
import CustomerSearch from "../../../../assets/images/c-serach.svg";
import { useTranslation } from "react-i18next";
import SalesHistoryDrawer from "./SalesHistoryDrawer";
import ReturnItemDrawer from "./ReturnItemDrawer";
import useTransactionStore from "../../../../stores/useTransactionStore";
import "../restaurantStyle.css";

const { Text } = Typography;
const { Option } = Select;

const OrderHistoryList = ({
  // order history data
  orderHistoryDetails,
  setOrderHistoryDetails,
  ordersCopy,
  orderColors,
  currenciesList,
  // search / filter
  searchHistoryInput,
  setSearchhistoryInput,
  setIsInputFocused,
  searchOrderHistory,
  filtersFlag,
  setFiltersFlag,
  dateRange,
  // loading
  loading,
  setLoading,
  // drawer state
  salesHistoryDrawer,
  setSalesHistoryDrawer,
  selectedOrder,
  setSelectedOrder,
  // return flow
  returnDrawerOpen,
  setReturnDrawerOpen,
  returnItem,
  setReturnItem,
  returnQty,
  setReturnQty,
  dataSource,
  setDataSource,
  setSelectedReturnOrder,
  setCheckedKeys,
  handleSaveReturnCartRecord,
  addSelectedReturnProductsToCart,
  getSalesHistoryData,
  searchReturnHistory,
  // return navigation
  setKeyValue,
  selectedReturnOrder,
  sortedSaleTypes,
  setSelectedSaleTypeIndex,
  handleSelectedSaleTypeForProducts,
  setSaleType,
  // print
  posConfig,
  ObFlag,
  CWHardwareController,
  isPrintModeXML,
  upsertPOSLog,
  dispatchEvent,
  // scroll / pagination
  dateRef,
}) => {
  const { t } = useTranslation();
  const [orderStatusFilter, setOrderStatusFilter] = useState("All Status");
  const scrollbarsRef = useRef(null);
  const debounceTimeoutRef = useRef(null);
  const [maxScroll, setMaxScroll] = useState(0);
  const [currentScroll, setCurrentScroll] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const fetchMoreData = (event) => {
    const lengthOff = parseInt(localStorage.getItem("dataLength")) || 0;
    const newMaxScroll = event.target.scrollHeight - event.target.clientHeight;
    const newCurrentScroll = event.target.scrollTop;

    setMaxScroll(newMaxScroll);
    setCurrentScroll(newCurrentScroll);

    if (scrollLeft !== event.target.scrollLeft) {
      setScrollLeft(event.target.scrollLeft);
      return;
    }

    if (Math.round(newCurrentScroll) >= Math.round(newMaxScroll) - 1 && !filtersFlag && ordersCopy.length > 0) {
      // The active date filter lives in a dedicated store field, not the sale's
      // orderType, so read it from salesHistoryFilter or pagination never resumes.
      let orderD = useTransactionStore.getState().salesHistoryFilter || [];
      const newStartRow = lengthOff;

      if (orderD.length > 0) {
        if (scrollbarsRef.current) {
          scrollbarsRef.current.scrollTop(Math.round(newCurrentScroll) - 5);
        }

        let dateFlag = true;
        if (dateRef.current?.textContent !== "Choose date range") {
          dateFlag = false;
        }

        clearTimeout(debounceTimeoutRef.current);
        debounceTimeoutRef.current = setTimeout(() => {
          setLoading(true);
          searchOrderHistory(orderD[0], orderD[1], newStartRow, true, dateFlag)
            .then((response) => {
              const newData = response?.data?.data?.salesHistory || [];
              localStorage.setItem("dataLength", (newStartRow + newData.length).toString());
              if (newData.length === 0) {
                setFiltersFlag(true);
              }
            })
            .catch((error) => {
              console.error("Error fetching more data:", error);
              message.error(t("Failed to load more records"));
              setFiltersFlag(true);
            })
            .finally(() => {
              setLoading(false);
            });
        }, 300);
      }
    }
  };

  useEffect(() => {
    const scrollbars = scrollbarsRef.current?.view;
    if (scrollbars) {
      scrollbars.addEventListener("scroll", fetchMoreData);
      return () => {
        scrollbars.removeEventListener("scroll", fetchMoreData);
        clearTimeout(debounceTimeoutRef.current);
      };
    }
  }, [salesHistoryDrawer, filtersFlag, ordersCopy]);

  return (
    <div className="order-history-root">
      <Row className="order-history-header-row" style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
        <Col span={12} className="order-history-title-col">
          <span style={{ paddingRight: "1vw", color: "#0F0718", fontSize: "1.8em", fontWeight: 500 }}>Orders History</span>
        </Col>
        <Col span={12} className="order-history-actions-col" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0.6vw" }}>
          <Input
            placeholder="Search for Customers/Document Number/Contact"
            prefix={<img src={CustomerSearch} style={{ width: "1.4em" }} alt="" />}
            style={{ width: "30vw" }}
            allowClear={false}
            onPressEnter={async (e) => {
              setLoading(true);
              try {
                localStorage.setItem("dataLength", "0");
                setFiltersFlag(false);
                if (e.target.value !== "") {
                  await searchOrderHistory("customer", e.target.value, 0, false, dateRange?.length > 0);
                } else if (dateRange?.length > 0) {
                  await searchOrderHistory("orderDateSearchKey", dateRange, 0, false);
                } else {
                  setOrderHistoryDetails([...ordersCopy]);
                  setFiltersFlag(false);
                }
              } catch (error) {
                console.error("Error during search:", error);
                message.error("Failed to search order history");
              } finally {
                setLoading(false);
              }
            }}
            onBlur={() => setIsInputFocused(false)}
            value={searchHistoryInput}
            id="sm-salesHistory-customer"
            onFocus={() => setIsInputFocused(true)}
            className="salesHistory-input-sm order-history-search-input"
            onChange={(e) => {
              const inputVal = e.target.value;
              setSearchhistoryInput(inputVal);
              if (inputVal === "") {
                setOrderHistoryDetails(ordersCopy);
                setFiltersFlag(false);
              }
            }}
          />

          <Select
            value={orderStatusFilter}
            onChange={(val) => setOrderStatusFilter(val)}
            className="salesHistory-status-dropdown order-history-status-select"
            style={{ width: "11vw", color: "rgba(0,0,0,0.45)" }}
            dropdownStyle={{ fontSize: "0.9vw" }}
          >
            <Option value="All Status">All Status</Option>
            <Option value="Pending">Pending</Option>
            <Option value="Completed">Completed</Option>
            <Option value="Cancelled">Cancelled</Option>
          </Select>
        </Col>
      </Row>

      <Scrollbars autoHide className="order-history-scrollbar" style={{ height: "90vh" }} ref={scrollbarsRef}>
        <Row className="order-history-list-row" style={{ marginTop: "1vh", paddingLeft: "1vw", paddingRight: "1vw" }}>
          {[...orderHistoryDetails]
            .sort((a, b) => {
              const aDoc = a.documentno?.replace(/\D/g, "") || "0";
              const bDoc = b.documentno?.replace(/\D/g, "") || "0";
              return parseInt(bDoc) - parseInt(aDoc);
            })
            .map((orderData) => {
              const dineText = orderData?.saleType?.name || "";
              const dineColor = orderColors[orderData.sOrderID] || "#000";

              return (
                <Col span={24} style={{ padding: "0.8vh 0" }} key={orderData.sOrderID}>
                  <Card
                    className="order-history-card"
                    style={{
                      borderRadius: "10px",
                      border: "1px solid #eee",
                      padding: "2vh 1.2vw",
                      cursor: "pointer",
                    }}
                    styles={{ body: { padding: 0 } }}
                    onClick={async () => {
                      try {
                        setLoading(true);
                        const fetchedData = await getSalesHistoryData(orderData.sOrderID);
                        if (fetchedData && fetchedData.length > 0) {
                          setSelectedOrder(fetchedData[0]);
                          setSalesHistoryDrawer(true);
                        }
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    <div className="order-history-card-body" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      {/* LEFT */}
                      <div className="order-history-card-left">
                        <div style={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
                          <span style={{ fontSize: "1.1em", fontWeight: 600, color: "#0F0718" }}>{orderData?.documentno}</span>
                          {posConfig?.showEstimateNoInSalesHistory === "Y" && (
                            <span style={{ fontSize: "0.85em", color: "#929098" }}>Estimate No: {orderData?.estimateDocumentNo || "-"}</span>
                          )}
                          <span
                            style={{
                              background: dineColor,
                              color: "#fff",
                              padding: "0.3em 0.7em",
                              borderRadius: "12px",
                              fontSize: "0.75em",
                              fontWeight: 500,
                            }}
                          >
                            {dineText}
                          </span>
                        </div>
                        <div
                          style={{
                            marginTop: "0.6vh",
                            fontSize: "0.9em",
                            color: "#929098",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.6vw",
                          }}
                        >
                          <span>
                            {orderData?.customer?.name || ""} • {orderData?.orderTime?.split(" ")[0] || ""}
                          </span>
                          <span>{orderData?.orderTime?.split(" ")[1] || ""}</span>
                        </div>
                      </div>

                      {/* RIGHT */}
                      <div className="order-history-card-right" style={{ display: "flex", alignItems: "center", gap: "1vw" }}>
                        <div className="order-history-card-amount" style={{ textAlign: "right" }}>
                          <div className="order-history-card-price" style={{ fontSize: "1.1em", fontWeight: 600, color: "#0F0718" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {orderData?.total || 0} {currenciesList[0].symbolRightSide === "N" ? `${currenciesList[0].currSymbol} ` : ""}
                          </div>
                          <div style={{ fontSize: "0.85em", color: "#929098" }}>{orderData?.totalQty || 0} items</div>
                        </div>
                        <RightOutlined style={{ fontSize: "0.9em", color: "#929098" }} />
                      </div>
                    </div>
                  </Card>
                </Col>
              );
            })}
        </Row>

        {filtersFlag && orderHistoryDetails.length > 0 && (
          <div style={{ textAlign: "center", padding: "2vh 0" }}>
            <Text style={{ fontSize: "1em", color: "#929098" }}>{t("No more records to load")}</Text>
          </div>
        )}

        <SalesHistoryDrawer
          salesHistoryDrawer={salesHistoryDrawer}
          setSalesHistoryDrawer={setSalesHistoryDrawer}
          selectedOrder={selectedOrder}
          setSelectedOrder={setSelectedOrder}
          loading={loading}
          setLoading={setLoading}
          currenciesList={currenciesList}
          posConfig={posConfig}
          searchReturnHistory={searchReturnHistory}
          setReturnItem={setReturnItem}
          setReturnQty={setReturnQty}
          setDataSource={setDataSource}
          setSelectedReturnOrder={setSelectedReturnOrder}
          setCheckedKeys={setCheckedKeys}
          setReturnDrawerOpen={setReturnDrawerOpen}
          ObFlag={ObFlag}
          CWHardwareController={CWHardwareController}
          isPrintModeXML={isPrintModeXML}
          upsertPOSLog={upsertPOSLog}
          dispatchEvent={dispatchEvent}
        />

        <ReturnItemDrawer
          returnDrawerOpen={returnDrawerOpen}
          setReturnDrawerOpen={setReturnDrawerOpen}
          returnItem={returnItem}
          dispatchEvent={dispatchEvent}
          returnQty={returnQty}
          setReturnQty={setReturnQty}
          currenciesList={currenciesList}
          dataSource={dataSource}
          setDataSource={setDataSource}
          handleSaveReturnCartRecord={handleSaveReturnCartRecord}
          setCheckedKeys={setCheckedKeys}
          addSelectedReturnProductsToCart={addSelectedReturnProductsToCart}
          setKeyValue={setKeyValue}
          selectedReturnOrder={selectedReturnOrder}
          selectedOrder={selectedOrder}
          sortedSaleTypes={sortedSaleTypes}
          setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
          handleSelectedSaleTypeForProducts={handleSelectedSaleTypeForProducts}
          setSaleType={setSaleType}
          setSalesHistoryDrawer={setSalesHistoryDrawer}
        />
      </Scrollbars>
    </div>
  );
};

export default React.memo(OrderHistoryList);
